import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Pouce = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.87 84.72">
  <G fill={color}>
    <Path d="M32.36,16.37c1.1,1.1,2.88,1.1,3.98,0,1.1-1.1,1.1-2.88,0-3.98l-3.98-3.97c-1.1-1.1-2.88-1.1-3.98,0s-1.1,2.88,0,3.97l3.98,3.98Z"/>
    <Path d="M64.16,16.37l3.98-3.98c1.1-1.1,1.1-2.88,0-3.97-1.1-1.1-2.88-1.1-3.98,0l-3.98,3.97c-1.1,1.1-1.1,2.88,0,3.98,1.1,1.1,2.88,1.1,3.98,0Z"/>
    <Path d="M48.26,11.43c1.57,0,2.81-1.24,2.81-2.81V2.81c0-1.58-1.24-2.81-2.81-2.81s-2.81,1.24-2.81,2.81v5.81c0,1.57,1.24,2.81,2.81,2.81Z"/>
    <Path d="M75.87,47.26c0-4.06-3.3-7.35-7.35-7.35h-14.59c2.07-3.74,3.16-7.27,3.16-12.14v-.79c0-2.62-1.01-5.09-2.85-6.96-1.84-1.87-3.04-2.92-5.66-2.96h-.08c-2.54,0-4.76,2.02-4.96,4.53-.99,11.99-10.11,21.28-21.06,23.34v35.68c8.36,3.63,15.62,4.11,23.96,4.11,1.43,0,2.88-.02,4.38-.03,1.66-.01,3.37-.03,5.17-.03h7.42c4.06,0,7.35-3.3,7.35-7.35,0-1.37-.37-2.64-1.02-3.74,2.11-1.29,3.53-3.62,3.53-6.28,0-1.36-.37-2.64-1.02-3.73,2.11-1.3,3.53-3.62,3.53-6.28,0-1.91-.73-3.66-1.93-4.96,1.25-1.32,2.02-3.09,2.02-5.05Z"/>
    <Path d="M17.7,42.92H2.45C1.1,42.92,0,44.02,0,45.37v36.13c0,1.35,1.1,2.45,2.45,2.45h10.04c3,0,7.66-.77,7.66-7.77v-30.81c0-1.35-1.1-2.45-2.45-2.45ZM12.52,79.62h-4.89v-9.36c0-1.36,1.1-2.45,2.45-2.45s2.45,1.1,2.45,2.45v9.36Z"/>
  </G>
</Svg>
);
};

export default Pouce;
